import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Auth.css';

const loginBg = require('./../../assets/images/login.png');
const torneaLogo = require('./../../assets/images/logo_text.png');

/* Shared layout for /login, /register, /forgot-password, /reset-password,
   /verify-account. Children are placed inside the central column (between
   hero text and the footer slot).

   `wide`: the central column follows the app column (--app-max-width) from a
   laptop up instead of staying at the 22rem form width. For shells that are a
   whole page rather than one form — the storefront and its checkout — which are
   read on a desktop far more often than the login screen is. */
const AuthShell = ({ title, subtitle, children, footer, hideBrand = false, wide = false }) => {
  const { t } = useTranslation();
  const [bg, setBg] = useState(() => {
    const stored = localStorage.getItem('backgroundPicture');
    return stored && stored.includes('http') ? stored : loginBg;
  });

  useEffect(() => {
    const refresh = () => {
      const stored = localStorage.getItem('backgroundPicture');
      setBg(stored && stored.includes('http') ? stored : loginBg);
    };
    // `storage` only fires in OTHER tabs; handleBranding dispatches
    // `branding-changed` for same-tab updates after fetching /branding.
    window.addEventListener('storage', refresh);
    window.addEventListener('branding-changed', refresh);
    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener('branding-changed', refresh);
    };
  }, []);

  return (
    <div className={`auth${wide ? ' auth--wide' : ''}`}>
      <div className="auth__bg" style={{ backgroundImage: `url(${bg})` }} />
      <div className="auth__shade" />

      <div className="auth__inner">
        {/* Brand pages (storefront) hide the Tornea wordmark: the page IS the
            brand's page, and hiding it lifts the content. */}
        {!hideBrand && (
          <div className="auth__brand">
            <a href="https://tornea.net" target="_blank" rel="noopener noreferrer">
              <img src={torneaLogo} alt="Tornea" className="auth__brand-logo" />
            </a>
          </div>
        )}

        {(title || subtitle) && (
          <div className="auth__hero">
            {title && <h1 className="auth__title">{title}</h1>}
            {subtitle && <p className="auth__subtitle">{subtitle}</p>}
          </div>
        )}

        {children}

        {footer}

        <p className="auth__legal">
          {t('legalNoticePrefix', { defaultValue: 'By continuing you agree to our' })}{' '}
          <Link to="/terms">
            {t('termsOfService', { defaultValue: 'Terms' })}
          </Link>{' '}
          {t('and', { defaultValue: 'and' })}{' '}
          <Link to="/privacy">
            {t('privacyPolicy', { defaultValue: 'Privacy Policy' })}
          </Link>.
        </p>
      </div>
    </div>
  );
};

export default AuthShell;
